<template>
  <th
    width="50"
    @click="$emit('click')"
    class="sortable noselect"
    :class="[`head-${col}`]">
    <span class="datagrid__control">
      <font-awesome-icon icon="sort-down" v-show="orderBy === col && order === 'DESC'" />
      <font-awesome-icon icon="sort-up" v-show="orderBy === col && order === 'ASC'" />
      <font-awesome-icon icon="sort" v-show="orderBy !== col" class="muted" />
    </span>
    {{ $t(`${entity}.cols.${col}`) }}
  </th>
</template>

<script>
export default {
  props: ['orderBy', 'order', 'entity', 'col', 'entry'],
};
</script>
